import { Slot } from '@radix-ui/react-slot'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { useDublicateGlobalPcSetMutation } from '@/entities/pricing-campaign'
import { Access } from '@/entities/session'

import { ampli } from '@/shared/lib/ampli'
import { queryClient } from '@/shared/lib/query-client'

export const DublicateGlobalPcSet = ({
	children,
	id,
}: {
	children: React.ReactNode
	id: string
}) => {
	const { t } = useTranslation()

	const dublicateGlobalPcSetMutation = useDublicateGlobalPcSetMutation({
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['global-pc-sets-list'],
			})
			queryClient.invalidateQueries({
				queryKey: ['pricing-campaigns'],
			})
			queryClient.invalidateQueries({
				queryKey: ['pricing-campaigns-overview'],
			})
		},
	})
	const handleDublicate = () => {
		ampli.globalPcSetActionClicked({
			global_pc_set_action: 'duplicate',
		})
		toast.promise(dublicateGlobalPcSetMutation.mutateAsync(id), {
			loading: t('duplicating.proccess', { defaultValue: 'Duplicating...' }),
			success: t('duplicating.success', {
				defaultValue: 'Duplicated successfully',
			}),
			error: t('duplicating.error', {
				defaultValue: 'Error while duplicating',
			}),
		})
	}

	return (
		<Access permissions={['CREATE_GLOBAL_PRICING_CAMPAIGNS']}>
			<Slot onClick={handleDublicate}>{children}</Slot>
		</Access>
	)
}
